// extracted by mini-css-extract-plugin
module.exports = {"fieldset":"RulePropertiesFieldset_fieldset__1Kcs9"};